import { Box, Button, Card, IconButton } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Delete, Edit, Visibility } from "@material-ui/icons";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Pagination,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { addDays, format } from "date-fns";
import React, { useState } from "react";
import Avatar from "react-avatar";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../../actions/loadingAction";
import {
  errorFetchJamaats,
  errorSnackbar,
  successSnackbar,
} from "../../../actions/snackbarActions";
import { Endpoint, Status } from "../../../apis/apiConstants";
import AjaxHelper from "../../../apis/apiRequest";
import MTextField from "../../../components/MTextField";
import MUserAutocomplete from "../../../components/MUserAutocomplete";
import NodataComponent from "../../../components/NodataComponent";
import {
  ResponsiveDialogActions,
  SnackbarType,
} from "../../../constants/appConstants";
import { isFieldEmpty } from "../../../helpers/appFieldValidation";
import { getCopy } from "../../../helpers/utils.helper";
import { setResponsiveDialog } from "../../../reducers/responsiveDialogReducer";
import { setSnackbar } from "../../../reducers/snackbarReducer";
import "./createAwards.scss";

const formFields = require("./awardfields.json");

export default function CreateAwards(props) {
  const [notifications, setNotifications] = useState([]);
  const [usersError, setUsersError] = useState("");
  const [awardPages, setAwardPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [openDetails, setOpenDetails] = React.useState(false);
  const [award, setAward] = React.useState({
    participants: [],
  });
  const navigate = useNavigate();
  const [userInput, setUserInput] = React.useState("");
  const [options, setOptions] = React.useState([]);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  React.useEffect(() => {
    getAllAwards(1);
    getAwardsCount();
  }, []);

  const getAllAwards = (page) => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, Endpoint.GET_AWARDS_ADMIN, {}, { page })
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          setNotifications(response.data.data);
        } else {
          dispatch(
            setSnackbar(true, SnackbarType.ERROR, response.data.message)
          );
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
        dispatch(errorFetchJamaats);
      });
  };

  const getSearchedUsers = (search) => {
    AjaxHelper.getApi(navigate, Endpoint.GET_SEARCH_USERS, null, { search })
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          const optionWithName = response.data.data.map((user) => {
            return {
              ...user,
              name: `${user.firstName} ${user.lastName}`,
            };
          });
          setOptions(optionWithName);

          console.log(optionWithName);
        } else {
          dispatch(errorSnackbar("Error fetching users list"));
        }
      })
      .catch((err) => {
        dispatch(errorSnackbar("Error fetching users list (catch error)"));
      });
  };

  const isAwardsDataValid = () => {
    let isValid = true;
    const updatedAward = getCopy(award);
    formFields.forEach((field) => {
      if (field.required && isFieldEmpty(award[field.key])) {
        isValid = false;
        updatedAward[
          `${field.key}Error`
        ] = `${field.label} is a required field.`;
      } else {
        updatedAward[`${field.key}Error`] = undefined;
      }
    });
    setAward(updatedAward);
    console.log(updatedAward);
    return isValid;
  };

  const addAwardsClick = () => {
    if (isAwardsDataValid()) {
      handleClose();
      dispatch(startLoading);
      if (award._id) {
        updateAward();
      } else {
        addAward();
      }
    }
  };

  const addAward = () => {
    const params = {
      ...award,
      participants: award.participants.map((p) => p._id),
    };
    AjaxHelper.postApi(navigate, Endpoint.ADD_AWARD, params)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_CREATED) {
          dispatch(successSnackbar("Award added successfully."));
          getAwardsData();
        } else {
          dispatch(errorSnackbar(response.data.message));
          getAwardsData();
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while adding award."));
      });
  };

  const updateAward = () => {
    const params = {
      ...award,
      participants: award.participants.map((p) => p._id),
    };
    AjaxHelper.postApi(navigate, Endpoint.UPDATE_AWARD, params)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          dispatch(successSnackbar("Award updated successfully."));
          getAwardsData();
        } else {
          dispatch(errorSnackbar("Error while updating award."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);

        dispatch(errorSnackbar("Error while updating award."));
      });
  };

  const deleteAward = (_id) => {
    dispatch(startLoading);
    AjaxHelper.postApi(navigate, Endpoint.DELETE_AWARD + `/${_id}`)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          dispatch(
            setSnackbar(true, SnackbarType.SUCCESS, response.data.message)
          );
          getAwardsData();
        } else {
          dispatch(
            setSnackbar(true, SnackbarType.ERROR, response.data.message)
          );
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
      });
  };

  const getParticipantVotes = (votes, participantId) => {
    const vote = votes.filter((v) => v.participantId === participantId);
    return vote.length > 0 ? vote[0].voteCount : 0;
  };

  const getParticipants = (participants, votes) => {
    participants = participants.map((p) => {
      return {
        ...p,
        name: `${p.firstName} ${p.lastName}`,
      };
    });
    return participants.map((user, index) => {
      return (
        <div className="createAwardsGetParticipants">
          <Avatar name={`${user.name}`} round={true} size={44} />
          <div>
            <div className={"appFontMedium"}>{user.name}</div>
            <div className={"appFont"}>{user.userCode}</div>
            <div className={"appFont"}>{`Votes - ${getParticipantVotes(
              votes,
              user._id
            )}`}</div>
          </div>
        </div>
      );
    });
  };

  const getAwardsView = () => {
    return notifications.map((a) => (
      <TableRow>
        <TableCell>
          <span className={"font-medium"}>{a.title}</span>
        </TableCell>
        <TableCell>
          <span className={"font-medium"}>{`${a.description.slice(
            0,
            100
          )}...`}</span>
        </TableCell>
        <TableCell>
          <span className={"font-medium"}>
            {format(new Date(a.expireDate), "dd MMM yyyy")}
          </span>
        </TableCell>
        <TableCell>
          {getParticipants(a.participants, a.participantsVote)}
        </TableCell>
        <TableCell align="center">
          <Tooltip title={"View"}>
            <IconButton
              onClick={(event) => {
                event.preventDefault();
                const b = getCopy(a);
                b.expireDate = format(new Date(b.expireDate), "dd MMMM yyyy");
                b.participants = b.participants.map((p) => {
                  return { ...p, name: `${p.firstName} ${p.lastName}` };
                });
                setAward(b);
                setOpenDetails(true);
              }}
            >
              <Visibility color={"primary"} />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Edit"}>
            <IconButton
              onClick={(event) => {
                event.preventDefault();
                const b = getCopy(a);
                b.expireDate = format(new Date(b.expireDate), "yyyy-MM-dd");
                console.log(b.participants);
                b.participants = b.participants.map((p) => {
                  return { ...p, name: `${p.firstName} ${p.lastName}` };
                });
                setAward(b);
                handleClickOpen();
              }}
            >
              <Edit style={{ color: "green" }} />
            </IconButton>
          </Tooltip>
          <Tooltip title={"Delete"}>
            <IconButton
              onClick={(event) => {
                event.preventDefault();
                dispatch(
                  setResponsiveDialog(
                    true,
                    "Delete award",
                    "Do you want to delete?",
                    "Yes",
                    "No",
                    (action) => {
                      if (action === ResponsiveDialogActions.POSITIVE) {
                        deleteAward(a._id);
                      }
                    }
                  )
                );
              }}
            >
              <Delete color={"error"} />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    ));
  };

  const getAwardsCount = () => {
    AjaxHelper.getApi(navigate, Endpoint.GET_AWARDS_PAGES)
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          setAwardPages(response.data.data.pages);
        }
      })
      .catch((error) => {
        // dispatch(errorFetchApplicants);
      });
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
    getAllAwards(page);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    event.preventDefault();
    let updatedAward = getCopy(award);
    updatedAward[event.target.name] = event.target.value;
    console.log(event.target.value);
    setAward(updatedAward);
  };

  const handleUserChange = (value) => {
    console.log(value);
    if (value) {
      console.log(award);
      const updatedAward = getCopy(award);
      if (updatedAward.participants) {
        updatedAward.participants.push(value);
      } else {
        updatedAward.participants = [value];
      }
      setAward(updatedAward);
      setOptions([]);
      setUserInput("");
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setUserInput(newInputValue);
    if (newInputValue.length === 4) {
      getSearchedUsers(newInputValue);
    }
    if (newInputValue.length === 3) {
      setOptions([]);
    }
  };

  const getAwardFormFields = () => {
    return formFields.map((field) => {
      if (field.type === "text" || field.type === "date") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-12 col-lg-12 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MTextField
              id={field.key}
              name={field.key}
              className="col-12"
              type={field.type}
              min={
                field.type === "date"
                  ? format(addDays(new Date(), 1), "yyyy-MM-dd")
                  : undefined
              }
              required={field.required}
              label={field.label}
              multiline={field.multiline ?? false}
              value={award[field.key]}
              onChange={handleChange}
              placeholder={field.placeholder}
              error={award[`${field.key}Error`] ? true : false}
              helperText={award[`${field.key}Error`]}
            />
          </div>
        );
      } else if (field.type === "users") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-12 col-lg-12 col-md-12") +
              "  col-12 d-flex flex-column justify-content-center align-items-center"
            }
          >
            <MUserAutocomplete
              label={"Users"}
              required={true}
              options={options}
              inputValue={userInput}
              value={null}
              onChange={(event, newValue) => {
                handleUserChange(newValue);
                if (newValue.length !== 2) {
                  setUsersError("Please select exactly two users.");
                } else {
                  setUsersError(null);
                }
              }}
              onInputChange={(event, newInputValue) =>
                handleInputChange(event, newInputValue)
              }
              error={Boolean(award[`${field.key}Error`] || usersError)}
              helperText={award[`${field.key}Error`] || usersError}
            />
            <div className="addAwardUser">
              {award.participants.map((user, index) => {
                return (
                  <div className="addAwardUserDetails">
                    <Avatar name={`${user.name}`} round={true} size={44} />
                    <div>
                      <div className={"appFontMedium"}>{user.name}</div>
                      <div className={"appFont"}>{user.userCode}</div>
                    </div>
                    <div>
                      <IconButton
                        onClick={() => {
                          const updatedPoc = [...award.participants];
                          updatedPoc.splice(index, 1);
                          setAward({
                            ...award,
                            participants: updatedPoc,
                          });
                        }}
                      >
                        <Delete color={"error"} />
                      </IconButton>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      }
    });
  };

  const getAwardDetailsFields = () => {
    return formFields.map((field) => {
      if (field.type === "text" || field.type === "date") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-12 col-lg-12 col-md-12") +
              "  col-12 d-flex justify-content-start align-items-center"
            }
          >
            <Box style={{ marginBottom: 8 }}>
              <div className={"appFontBold"}>{field.label}</div>
              <div className={"appFont"}>{award[field.key]}</div>
            </Box>
          </div>
        );
      } else if (field.type === "users") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-12 col-lg-12 col-md-12") +
              "  col-12 d-flex flex-column justify-content-start align-items-start"
            }
          >
            <div className={"appFontBold"} style={{ marginBottom: 8 }}>
              Participants
            </div>
            <div className="getAwardDetailsFields">
              {award.participants.map((user, index) => {
                return (
                  <div className="getAwardDetailsFieldsParticipants">
                    <Avatar name={`${user.name}`} round={true} size={44} />
                    <div>
                      <div className={"appFontMedium"}>{user.name}</div>
                      <div className={"appFont"}>{user.userCode}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      }
    });
  };

  const getAwardsData = () => {
    getAllAwards(currentPage);
    getAwardsCount();
  };

  return (
    <div className={"notification-component d-flex flex-column p-md-3"}>
      <div className="d-flex flex-row align-items-center justify-content-between p-md-0 p-3">
        <div className="d-flex flex-row justify-content-center align-content-center"></div>
        <Button
          variant="contained"
          className="button"
          color="primary"
          onClick={() => {
            setAward({
              participants: [],
            });
            handleClickOpen();
          }}
        >
          Add
        </Button>
      </div>
      <Card className="innerCard mt-3 " variant="outlined">
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow className={"background-color-head"}>
                <TableCell>
                  <span className={"font-bold font-18"}>Title</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Description</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Expire on</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Participants</span>
                </TableCell>
                <TableCell align="center">
                  <span className={"font-bold font-18"}>Action</span>
                </TableCell>
              </TableRow>
            </TableHead>
            {getAwardsView()}
          </Table>
        </TableContainer>
        {notifications.length > 0 ? null : <NodataComponent />}
        {awardPages > 0 ? (
          <Pagination
            className={"mpagination"}
            count={awardPages}
            variant="outlined"
            shape="rounded"
            onChange={(event, page) => onPageChange(page)}
          />
        ) : null}
      </Card>

      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogTitle className={"background-color-head"}>
          <span className={"font-bold font-18"}>
            {award?._id ? "Update award" : "Add award"}
          </span>
        </DialogTitle>
        <Divider />

        <div className={"jamaat-form"}>{getAwardFormFields()}</div>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            variant="outlined"
            onClick={() => {
              addAwardsClick();
            }}
          >
            {award._id ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={openDetails}
        onClose={() => {
          setOpenDetails(false);
        }}
      >
        <DialogTitle className={"background-color-head"}>
          <span className={"font-bold font-18"}>{"Award details"}</span>
        </DialogTitle>
        <Divider />

        <div className={"jamaat-form"}>{getAwardDetailsFields()}</div>
        <DialogActions>
          <Button onClick={() => setOpenDetails(false)}>Ok</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
